import { useSupabase } from "~/composables/useSupabase";
export const useProtectedRoute = function () {
  const supabase = useSupabase();

  const checkTokens = () => {
    const accessToken = useCookie("sb-access-token");
    const refreshToken = useCookie("sb-refresh-token");
    return accessToken.value && refreshToken.value;
  };

  const refreshTokens = async () => {
    await supabase.auth.refreshSession();
  };

  const customFetch = async (url: string, options?: RequestInit): Promise<Response> => {
    if (!checkTokens()) await refreshTokens();

    return fetch(url, options);
  };

  return { customFetch, checkTokens, refreshTokens };
};
